"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const ItemUser_1 = __importDefault(require("./component/ItemUser"));
const styles_1 = __importDefault(require("./styles"));
const keyExtractor = (_, index) => `${index}`;
const ListCommentScreen = (props) => {
    const { articleId, } = props.route.params;
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [comments, setComments] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [articleTitle, setArticleTitle] = (0, react_1.useState)('');
    const refCurrentPage = (0, react_1.useRef)(1);
    const refIsNoMore = (0, react_1.useRef)(false);
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        if (connected) {
            setComments([]);
            refCurrentPage.current = 1;
            refIsNoMore.current = false;
            loadComments();
        }
    }, [connected]));
    (0, react_1.useEffect)(() => {
        if (articleId && connected) {
            callApiDetail();
        }
    }, [articleId, connected]);
    const displayTweet = (data) => {
        let listData = comments.filter((item) => item?.article_comment_id != data);
        setComments(listData);
    };
    const callApiDetail = async () => {
        await Article_1.default.getArticleDetail(articleId).then((res) => {
            setArticleTitle(res.data.data?.title);
        });
    };
    const loadComments = () => {
        if (refIsNoMore.current || isLoading)
            return;
        setLoading(true);
        Article_1.default.getArticleListComment(articleId, refCurrentPage.current)
            .then(response => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
            }
            if (response?.data?.data?.length > 0) {
                setComments([...comments, ...response.data.data]);
            }
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
        } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: articleTitle, styleContainer: {
                backgroundColor: 'white',
                marginBottom: 0,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }), onLeftPress: () => (0, rootNavigation_1.goBack)() }),
        react_1.default.createElement(react_native_1.FlatList, { data: comments, keyExtractor: keyExtractor, renderItem: ({ item }) => (react_1.default.createElement(ItemUser_1.default, { data: item, articleId: articleId, displayTweet: (data) => displayTweet(data) })), onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    loadComments();
                }
            }, scrollEventThrottle: 400, ListFooterComponent: isLoading ? react_1.default.createElement(components_1.LoadingView, { style: styles_1.default.loading }) : null, contentContainerStyle: { paddingBottom: (0, scale_1.scale)(60), paddingTop: (0, scale_1.scale)(24) }, showsVerticalScrollIndicator: false })));
};
exports.default = ListCommentScreen;
